import { useState } from "react";
import { SecondaryLinkButton } from "../../../../Component/RetailerComponents/invoice/SecondaryLinkButton";
import { PrimaryLinkButton } from "../../../../Component/RetailerComponents/invoice/PrimaryLinkButton";
import { cn, isPayEnabled, moneyINR, prettyDate, statusLabel, statusTone } from "./invoiceUtils";

import { Badge } from "../../../../Component/RetailerComponents/invoice/Badge";
import { Stat } from "../../../../Component/RetailerComponents/invoice/Stat";
import { Row } from "../../../../Component/RetailerComponents/invoice/Row";
import { TestSuite } from "../../../../Component/RetailerComponents/invoice/TestSuite";
import { formatDateTime } from "../../../../Component/Common/formatDateTime";


function Icon({ name, className }) {
  const common = "fill-none stroke-current";
  const props = {
    className: cn("h-5 w-5", className),
    viewBox: "0 0 24 24",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  if (name === "link")
    return (
      <svg {...props} className={cn(props.className, common)}>
        <path d="M10 13a5 5 0 0 0 7.07 0l1.41-1.41a5 5 0 0 0-7.07-7.07L10.5 4.43" />
        <path d="M14 11a5 5 0 0 0-7.07 0L5.52 12.4a5 5 0 0 0 7.07 7.07l.9-.9" />
      </svg>
    );

  if (name === "copy")
    return (
      <svg {...props} className={cn(props.className, common)}>
        <rect x="9" y="9" width="13" height="13" rx="2" />
        <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
      </svg>
    );

  if (name === "check")
    return (
      <svg {...props} className={cn(props.className, common)}>
        <path d="M20 6 9 17l-5-5" />
      </svg>
    );

  if (name === "user")
    return (
      <svg {...props} className={cn(props.className, common)}>
        <path d="M20 21a8 8 0 1 0-16 0" />
        <circle cx="12" cy="7" r="4" />
      </svg>
    );

  if (name === "receipt")
    return (
      <svg {...props} className={cn(props.className, common)}>
        <path d="M7 3h10a2 2 0 0 1 2 2v16l-2-1-2 1-2-1-2 1-2-1-2 1-2-1-2 1V5a2 2 0 0 1 2-2z" />
        <path d="M9 7h6" />
        <path d="M9 11h6" />
        <path d="M9 15h4" />
      </svg>
    );

  if (name === "pin")
    return (
      <svg {...props} className={cn(props.className, common)}>
        <path d="M12 22s7-4.5 7-11a7 7 0 1 0-14 0c0 6.5 7 11 7 11z" />
        <circle cx="12" cy="11" r="2.5" />
      </svg>
    );

  if (name === "clock")
    return (
      <svg {...props} className={cn(props.className, common)}>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v6l4 2" />
      </svg>
    );

  return (
    <svg {...props} className={cn(props.className, common)}>
      <circle cx="12" cy="12" r="9" />
    </svg>
  );
}
export default function InvoiceDetails({ invoice, onBack, copyLink }) {
  const [copied, setCopied] = useState(false);

  const authUser = JSON.parse(localStorage.getItem("authUserData") || "{}");

  const isRetailerMobile =
    typeof window !== "undefined" &&
    window.innerWidth < 640 &&
    Number(authUser?.role) === 5;
  

  return (
    <div
      className={cn(
        "min-h-screen",
        isRetailerMobile
          ? "glass-card bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
          : "bg-slate-50"
      )}
    >
      {/* Sticky back */}
      <div
        className={cn(
          "sticky top-0 z-30 backdrop-blur border-b",
          isRetailerMobile
            ? "bg-white/10 border-white/20"
            : "bg-slate-50/80 border-slate-200/60"
        )}
      >
        <div className="mx-auto  px-4 py-3 sm:px-6">
          <div className="flex items-center justify-end gap-3">
            {/* <button
              onClick={() => onBack()}
              className="inline-flex items-center gap-2 rounded-2xl bg-white border border-slate-200 px-4 py-2 text-sm font-extrabold text-slate-900 hover:bg-slate-50"
            >
              ← Invoice List
            </button> */}

            <div className="flex items-center gap-2">
              {/* <PrimaryLinkButton href={invoice.invoice_url} label="Pay Now" enabled={isPayEnabled(invoice)} /> */}
              <SecondaryLinkButton href={invoice.invoice_url} label="View" />
              <SecondaryLinkButton href={invoice.invoice_url} label="Download" />
              {/* <button
                onClick={() => copyLink(invoice.invoice_url)}
                className="inline-flex items-center gap-2 rounded-2xl bg-white border border-slate-200 px-4 py-2 text-sm font-extrabold text-slate-900 hover:bg-slate-50"
                title="Copy invoice link"
              >
                {copied ? <Icon name="check" /> : <Icon name="copy" />}
                {copied ? "Copied" : "Copy"}
              </button> */}
            </div>
          </div>
        </div>
      </div>

      {/* Top gradient */}
      <div className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-600 via-indigo-600 to-sky-500 opacity-90" />
        <div className="absolute -top-24 -left-24 h-72 w-72 rounded-full bg-white/15 blur-2xl" />
        <div className="absolute -bottom-28 -right-24 h-80 w-80 rounded-full bg-white/10 blur-2xl" />

        <div className="relative mx-auto  px-4 pb-6 pt-6 sm:px-6">
          <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
            <div className="flex items-start gap-3">
              <div className="rounded-2xl bg-white/15 backdrop-blur border border-white/20 p-3 shadow-sm">
                <Icon name="receipt" className="h-6 w-6 text-white" />
              </div>
              <div>
                <div className="flex flex-wrap items-center gap-2">
                  <h1 className="text-xl sm:text-2xl font-extrabold text-white">Invoice {invoice?.invoice_number}</h1>
                  <Badge tone={statusTone(invoice)}>{statusLabel(invoice)}</Badge>
                  <Badge tone="slate">{invoice?.invoice_source}</Badge>
                </div>
                <div className="mt-1 text-sm text-white/85">
                  Ref: <span className="font-semibold text-white">{invoice?.reference_number}</span>
                </div>
                <div className="mt-1 text-xs text-white/75">Invoice ID: {invoice?.invoice_id}</div>
              </div>
            </div>
          </div>

          {/* Quick stats */}
          <div className="mt-5 grid grid-cols-2 gap-3 sm:grid-cols-4">
            <Stat
              label="Total"
              value={moneyINR(invoice?.total)}
              sub={`${invoice?.currency_code} • Tax ${moneyINR(invoice?.tax_total)}`}
            />
            <Stat
              label="Paid"
              value={moneyINR(invoice?.payment_made)}
              sub={`Last payment: ${prettyDate(invoice?.last_payment_date)}`}
            />
            <Stat
              label="Balance"
              value={moneyINR(invoice?.balance)}
              sub={Number(invoice?.balance || 0) === 0 ? "No dues" : "Payment pending"}
            />
            <Stat
              label="Due Date"
              value={prettyDate(invoice?.due_date)}
              sub={`Invoice date: ${prettyDate(invoice?.date)}`}
            />
          </div>
        </div>
      </div>

      {/* Body */}
      <div className="mx-auto  px-4 py-6 sm:px-6">
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-3">
          {/* Customer */}
          <div className={cn(
        "",
        isRetailerMobile
          ? "glass-card bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
          : "min-h-screen bg-slate-50"
      )}>
            <div className="p-5">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className="rounded-2xl bg-blue-50 border border-blue-100 p-2">
                    <Icon name="user" className="text-blue-700" />
                  </div>
                  <div>
                    <div className="text-sm font-extrabold text-slate-900">Customer</div>
                    <div className="text-xs text-slate-500">
                      {invoice.contact_number} • {invoice.customer_id}
                    </div>
                  </div>
                </div>
                <Badge tone={Number(invoice.credits_applied || 0) > 0 ? "amber" : "slate"}>
                  Credits: {moneyINR(invoice.credits_applied)}
                </Badge>
              </div>

              <div className="mt-4">
                <div className="text-lg font-extrabold text-slate-900 leading-tight">{invoice.customer_name}</div>
                <div className="mt-1 text-sm text-slate-600 break-all">{invoice.email}</div>
              </div>

              <div className={cn(
        "mt-4 rounded-2xl p-4",
        isRetailerMobile
          ? "bg-white/10 backdrop-blur-xl border-white/30 text-white"
          : "bg-slate-50 border border-slate-200/60 "
      )}>
                <div className="text-xs font-bold text-slate-700">Primary Contact</div>
                <div className="mt-1 text-sm font-semibold text-slate-900">{invoice.contact_person?.name || "—"}</div>
                <div className="mt-1 text-sm text-slate-600">Phone: {invoice.contact_person?.phone || "—"}</div>
                <div className="mt-1 text-sm text-slate-600 break-all">Email: {invoice.contact_person?.email || "—"}</div>
              </div>

              <div className={cn(
        "mt-4 rounded-2xl p-4",
        isRetailerMobile
          ? "bg-white/10 backdrop-blur-xl border-white/30 text-white"
          : "bg-slate-50 border border-slate-200/60 "
      )}>
                <div className="flex items-center gap-2">
                  <Icon name="pin" className="text-slate-700" />
                  <div className="text-xs font-bold text-slate-700">Billing Address</div>
                </div>
                <div className="mt-2 text-sm text-slate-700">
                  <div className="font-semibold text-slate-900">{invoice.billing_address?.attention || "—"}</div>
                  <div>
                    {invoice.billing_address?.street || ""}
                    {invoice.billing_address?.street2 ? `, ${invoice.billing_address.street2}` : ""}
                  </div>
                  <div>
                    {invoice.billing_address?.city || ""}, {invoice.billing_address?.state || ""} - {invoice.billing_address?.zip || ""}
                  </div>
                  <div>{invoice.billing_address?.country || ""}</div>
                  <div className="mt-1">Phone: {invoice.billing_address?.phone || "—"}</div>
                </div>
              </div>

              {/* <div className="mt-4 text-xs text-slate-500">
                Template: <span className="font-semibold text-slate-700">{invoice.template_name}</span>
              </div> */}
            </div>
          </div>

          {/* Line items + totals */}
          <div className="lg:col-span-2 space-y-4">
            <div className={cn(
                "rounded-3xl shadow-sm border",
                isRetailerMobile
                  ? "bg-white/10 backdrop-blur-2xl border-white/30 text-white"
                  : "bg-white border-slate-200/60"
              )}>
              <div className="p-5 flex items-center justify-between">
                <div>
                  <div className="text-sm font-extrabold text-slate-900">Line Items</div>
                  <div className="text-xs text-slate-500">Products / Services billed in this invoice</div>
                </div>
                <Badge tone="blue">Items: {invoice.line_items?.length || 0}</Badge>
              </div>

              <div className="px-5 pb-5">
                {/* Mobile items */}
                <div className="grid gap-3 md:hidden">
                  {(invoice.line_items || []).map((it, idx) => (
                    <div key={idx} className={cn(
                        "rounded-3xl border p-4",
                        isRetailerMobile
                          ? "bg-white/10 backdrop-blur-xl border-white/30 text-white"
                          : "border-slate-200/60 bg-slate-50"
                      )}>
                      <div className="text-sm font-extrabold text-slate-900">{it.name}</div>
                      <div className="mt-0.5 text-xs text-slate-500">{it.description || "—"}</div>
                      <div className="mt-3 grid grid-cols-2 gap-2 text-sm">
                        <div className={cn(
                        "rounded-2xl border p-3",
                        isRetailerMobile
                          ? "bg-white/10 backdrop-blur-xl border border-white/30 text-white"
                          : "bg-white border border-slate-200/60"
                      )}>
                          <div className="text-[11px] text-slate-500 font-bold">Qty</div>
                          <div className="mt-0.5 font-semibold text-slate-900">{it.quantity}</div>
                        </div>
                        <div className={cn(
                        "rounded-2xl border p-3",
                        isRetailerMobile
                          ? "bg-white/10 backdrop-blur-xl border border-white/30 text-white"
                          : "bg-white border border-slate-200/60"
                      )}>
                          <div className="text-[11px] text-slate-500 font-bold">Rate</div>
                          <div className="mt-0.5 font-semibold text-slate-900">{moneyINR(it.rate)}</div>
                        </div>
                        <div className={cn(
                        "rounded-2xl border p-3",
                        isRetailerMobile
                          ? "bg-white/10 backdrop-blur-xl border border-white/30 text-white"
                          : "bg-white border border-slate-200/60"
                      )}>
                          <div className="text-[11px] text-slate-500 font-bold">Tax</div>
                          <div className="mt-0.5 font-semibold text-slate-900">{Number(it.tax_percentage || 0)}%</div>
                        </div>
                        <div className={cn(
                        "rounded-2xl border p-3",
                        isRetailerMobile
                          ? "bg-white/10 backdrop-blur-xl border border-white/30 text-white"
                          : "bg-white border border-slate-200/60"
                      )}>
                          <div className="text-[11px] text-slate-500 font-bold">Total</div>
                          <div className="mt-0.5 font-extrabold text-slate-900">{moneyINR(it.item_total)}</div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Desktop table */}
                <div className="hidden md:block overflow-hidden rounded-2xl border border-slate-200/60">
                  <div className={cn(
                    "grid grid-cols-12",
                    isRetailerMobile
                      ? "glass-card bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
                      : "bg-slate-50 px-4 py-3 text-xs font-bold text-slate-600"
                  )}>
                    <div className="col-span-6">Item</div>
                    <div className="col-span-2 text-right">Qty</div>
                    <div className="col-span-2 text-right">Rate</div>
                    <div className="col-span-2 text-right">Total</div>
                  </div>
                  <div className="divide-y divide-slate-200/60">
                    {(invoice.line_items || []).map((it, idx) => (
                      <div key={idx} className="grid grid-cols-12 px-4 py-3">
                        <div className="col-span-6">
                          <div className="text-sm font-extrabold text-slate-900">{it.name}</div>
                          <div className="mt-0.5 text-xs text-slate-500">{it.description || "—"}</div>
                          <div className="mt-1 flex flex-wrap gap-2 text-xs">
                            <span className="inline-flex items-center rounded-full bg-slate-100 px-2 py-0.5 text-slate-700">
                              Tax: {Number(it.tax_percentage || 0)}%
                            </span>
                            <span className="inline-flex items-center rounded-full bg-slate-100 px-2 py-0.5 text-slate-700">
                              Discount: {moneyINR(it.discount || 0)}
                            </span>
                          </div>
                        </div>
                        <div className="col-span-2 text-right text-sm font-semibold text-slate-700">{it.quantity}</div>
                        <div className="col-span-2 text-right text-sm font-semibold text-slate-700">{moneyINR(it.rate)}</div>
                        <div className="col-span-2 text-right text-sm font-extrabold text-slate-900">{moneyINR(it.item_total)}</div>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2">
                  <div className="rounded-2xl bg-gradient-to-br from-blue-50 to-indigo-50 border border-blue-100 p-4">
                    <div className="text-xs font-bold text-blue-700">Notes</div>
                    <div className="mt-1 text-sm text-slate-700">{invoice.notes || "—"}</div>
                    <div className="mt-3 text-xs text-blue-700/80">
                      Tip: Map warranty activation to <span className="font-semibold">reference_number</span>.
                    </div>
                  </div>

                  <div className={cn(
                      "mt-4 rounded-2xl p-4",
                      isRetailerMobile
                        ? "bg-white/10 backdrop-blur-2xl border-white/40 text-white"
                        : "bg-slate-50 border border-slate-200/60 "
                    )}>
                    <div className="flex items-center justify-between">
                      <div className="text-sm font-extrabold text-slate-900">Total Summary</div>
                      <Badge tone={Number(invoice.balance || 0) === 0 ? "green" : "amber"}>
                        {Number(invoice.balance || 0) === 0 ? "Settled" : "Pending"}
                      </Badge>
                    </div>

                    <div className="mt-3 space-y-2 text-sm">
                      <Row label="Sub Total" value={moneyINR(invoice.sub_total)} />
                      <Row label="Tax" value={moneyINR(invoice.tax_total)} />
                      <Row label="Discount" value={moneyINR(invoice.discount_total)} />
                      <Row label="Adjustments" value={moneyINR(invoice.adjustment)} />
                      <Row label="Write-off" value={moneyINR(invoice.write_off_amount)} />
                      <div className="my-2 h-px bg-slate-200/60" />
                      <Row
                        label={<span className="font-extrabold">Total</span>}
                        value={<span className="font-extrabold">{moneyINR(invoice.total)}</span>}
                      />
                      <Row label="Paid" value={moneyINR(invoice.payment_made)} />
                      <Row
                        label={<span className="font-extrabold">Balance</span>}
                        value={<span className="font-extrabold">{moneyINR(invoice.balance)}</span>}
                      />
                    </div>

                    <div className="mt-4 flex flex-wrap gap-2">
                      <SecondaryLinkButton href={invoice.invoice_url} label="View" size="sm" />
                      {/* <PrimaryLinkButton
                        href={invoice.invoice_url}
                        label="Pay Now"
                        size="sm"
                        enabled={isPayEnabled(invoice)}
                      /> */}
                      <SecondaryLinkButton href={invoice.invoice_url} label="Download" size="sm" />
                      <button
                        onClick={() => copyLink(invoice.invoice_url)}
                        className={cn(
                          "inline-flex items-center justify-center rounded-2xl px-4 py-2 text-sm font-bold transition",
                          isRetailerMobile
                            ? "bg-white/10 backdrop-blur-xl border border-white/30 text-black hover:bg-white/20"
                            : "bg-white border border-slate-200 text-slate-800 hover:bg-slate-50"
                        )}
                      >
                        Copy Link
                      </button>
                    </div>

                    <div className="mt-3 text-xs text-slate-500 break-all">
                      <span className="font-semibold">Link:</span> {invoice.invoice_url}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Timeline / Audit */}
            <div
            className={cn(
        "rounded-3xl p-5",
        isRetailerMobile
          ? "glass-card bg-white/10 backdrop-blur-2xl border border-white/30 shadow-[0_20px_50px_rgba(31,38,135,0.25)]"
          : "bg-white shadow-sm border border-slate-200/60"
      )}>
              <div className="flex items-center gap-2">
                <div className="rounded-2xl bg-slate-50 border border-slate-200/60 p-2">
                  <Icon name="clock" className="text-slate-700" />
                </div>
                <div>
                  <div className="text-sm font-extrabold text-slate-900">Audit Trail</div>
                  <div className="text-xs text-slate-500">Created & last modified timestamps</div>
                </div>
              </div>

              <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-3">
                <div  className={cn(
        "rounded-2xl p-4",
        isRetailerMobile
          ? "bg-white/10 backdrop-blur-xl border-white/30 text-white"
          : " bg-slate-50 border border-slate-200/60 "
      )}>
                  <div className="text-xs font-bold text-slate-600">Created</div>
                  <div className="mt-1 text-sm font-extrabold text-slate-900">{formatDateTime(invoice.created_time)}</div>
                  <div className="mt-1 text-xs text-slate-500">By: {invoice.created_by_name}</div>
                </div>
                <div className={cn(
        "rounded-2xl p-4",
        isRetailerMobile
          ? "bg-white/10 backdrop-blur-xl border-white/30 text-white"
          : " bg-slate-50 border border-slate-200/60 "
      )}>
                  <div className="text-xs font-bold text-slate-600">Last Modified</div>
                  <div className="mt-1 text-sm font-extrabold text-slate-900">{formatDateTime(invoice.last_modified_time)}</div>
                  <div className="mt-1 text-xs text-slate-500">Status: {invoice.current_sub_status}</div>
                </div>
                <div className={cn(
        "rounded-2xl p-4",
        isRetailerMobile
          ? "bg-white/10 backdrop-blur-xl border-white/30 text-white"
          : " bg-slate-50 border border-slate-200/60 "
      )}>
                  <div className="text-xs font-bold text-emerald-700">Payment</div>
                  <div className="mt-1 text-sm font-extrabold text-slate-900">{moneyINR(invoice.payment_made)}</div>
                  <div className="mt-1 text-xs text-emerald-700/80">Last payment date: {prettyDate(invoice.last_payment_date)}</div>
                </div>
              </div>

              <div className={cn(
        "rounded-2xl p-4 mt-3",
        isRetailerMobile
          ? "bg-white/10 backdrop-blur-xl border-white/30 text-white"
          : " bg-slate-50 border border-slate-200/60"
      )}>
                <div className="text-xs font-extrabold text-slate-800">Quick Checks</div>
                <ul className="mt-4 grid grid-cols-1 gap-2 text-sm text-slate-700 sm:grid-cols-2">
                  <li className="flex items-center gap-2">
                    <span
                      className={cn(
                        "h-2 w-2 rounded-full",
                        Number(invoice.credits_applied || 0) > 0 ? "bg-amber-500" : "bg-emerald-500"
                      )}
                    />
                    Credit note applied:{" "}
                    <span className="font-bold">{Number(invoice.credits_applied || 0) > 0 ? "YES" : "NO"}</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span
                      className={cn(
                        "h-2 w-2 rounded-full",
                        Number(invoice.adjustment || 0) !== 0 ? "bg-amber-500" : "bg-emerald-500"
                      )}
                    />
                    Adjustment:{" "}
                    <span className="font-bold">{Number(invoice.adjustment || 0) !== 0 ? "YES" : "NO"}</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span
                      className={cn(
                        "h-2 w-2 rounded-full",
                        Number(invoice.write_off_amount || 0) !== 0 ? "bg-amber-500" : "bg-emerald-500"
                      )}
                    />
                    Write-off:{" "}
                    <span className="font-bold">{Number(invoice.write_off_amount || 0) !== 0 ? "YES" : "NO"}</span>
                  </li>
                  <li className="flex items-center gap-2">
                    <span
                      className={cn(
                        "h-2 w-2 rounded-full",
                        Number(invoice.balance || 0) === 0 ? "bg-emerald-500" : "bg-rose-500"
                      )}
                    />
                    Balance due:{" "}
                    <span className="font-bold">{Number(invoice.balance || 0) === 0 ? "NO" : "YES"}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-6 text-center text-xs text-slate-400">© {new Date().getFullYear()} Goelectronix Technologies Private Limited</div>
      </div>

      {/* Lightweight tests (won't run unless enabled) */}
      <TestSuite />
    </div>
  );
}
